<template>
  <div :class="$style.container">
    <div :class="$style.anchor"></div>
    <FormFilter
      :config="config"
      @filtered="displayResults"
      @has-results="displayPagination"
    />
    <div :class="[$style.results, 'columns is-multiline']">
      <div
        :key="index"
        v-for="(result, index) in displayedResults"
        :class="[
          'column',
          'is-half-tablet',
          'is-half-desktop',
          { [$style.highlightResults]: highlightResults && index < 2 }
        ]"
      >
        <ProductTeaser
          :result="result"
          :config="config.texts"
          :additionalUrlParam="additionalUrlParam"
        />
      </div>
    </div>
    <Pagination
      v-show="config.loadInitialData || hasResults"
      :config="config.pagination"
      :results="results.length"
      @update="displayPaginatedResults"
    />
  </div>
</template>

<script>
import FormFilter from "../FormFilter/FormFilter.vue";
import ProductTeaser from "../ProductTeaser/ProductTeaser";
import Pagination from "../Pagination/Pagination.vue";

export default {
  name: "BranchList",
  components: {
    FormFilter,
    ProductTeaser,
    Pagination
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      results: [],
      displayRange: [0, this.config.resultsPerPage - 1],
      displayedResults: [],
      labels: this.config.texts,
      hasResults: false,
      highlightResults: false
    };
  },
  computed: {
    additionalUrlParam: function() {
      if (
        window.wtParamCollection &&
        window.wtParamCollection["WT.i_overview"]
      ) {
        return `WT.cg_s=${window.wtParamCollection["WT.i_overview"]}`;
      }
      return "";
    }
  },
  methods: {
    displayPagination(hasResults) {
      this.hasResults = hasResults;
    },
    displayResults(results) {
      this.results = results;
      this.displayedResults = [];
      for (let i = 0; i < this.results.length; i++) {
        if (i >= this.displayRange[0] && i <= this.displayRange[1]) {
          this.displayedResults.push(this.results[i]);
        } else if (i > this.displayRange[1]) {
          break;
        }
      }
    },
    displayPaginatedResults(displayRange) {
      this.displayRange = displayRange;
      this.displayResults(this.results);
    },
    updateFromLink(filter) {
      if (filter.id === "all") {
        this.highlightResults = false;
      } else if (filter.id) {
        this.highlightResults = true;
      }
    }
  },
  mounted() {
    window.addEventListener("updateFilter", event => {
      this.updateFromLink(event.detail);
    });
  }
};
</script>

<style module lang="scss">
@import "./BranchList.scss";
</style>
